<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";

  const iconProps = getIconProps("outreach");
</script>

<Slide>
  <LicenseChip {style} license="outreach" />
  <H1>Turn your to-dos into done</H1>
  <P>
    Your daily outreach, simplified. Prioritise tasks, follow up at the right
    time, and never miss a step - all from your to-Do’s.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-ballot-check" {...iconProps} />Stay organized and
      accountable
    </Bullet>
    <Bullet>
      <IconScale class="fa-chart-simple" {...iconProps} />Keep momentum high
    </Bullet>
    <Bullet>
      <IconScale class="fa-eye" {...iconProps} />Nothing slips through the
      cracks
    </Bullet>
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/27m05qb" />
</Slide>
